"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface LeavingGuardProps {
  showDialog: boolean;
  onConfirmLeave?: () => void;
  onCancelLeave?: () => void;
  title?: string;
  description?: string;
}

export function LeavingGuard({
  showDialog,
  onConfirmLeave,
  onCancelLeave,
  title = "Unsaved Changes",
  description = "You have unsaved changes. Are you sure you want to leave? All your changes will be lost.",
}: LeavingGuardProps) {
  return (
    <Dialog open={showDialog} onOpenChange={onCancelLeave}>
      <DialogContent
        overlayClassName="bg-zinc-200/40"
        className="top-12 translate-y-0"
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancelLeave}>
            Stay
          </Button>
          <Button variant="destructive" onClick={onConfirmLeave}>
            Leave
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
